import type { SxProps, Theme } from "@mui/material";

/**
 * Shared layout styles – use across full-page and full-width components
 * for consistent width: 100%, viewport height, box model, and responsiveness.
 *
 * Going forward: use fullWidth/fullPage* for roots; formMaxWidth for forms;
 * responsive breakpoints (xs, sm, md, lg) for padding and typography.
 */

/** Full viewport page: fills screen, centered content, responsive padding */
export const fullPageCentered: SxProps<Theme> = {
  width: "100%",
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  px: { xs: 2, sm: 3, md: 4 },
  py: { xs: 3, sm: 4, md: 6 },
};

/** Full viewport page without centering (e.g. layout wrapper) */
export const fullPage: SxProps<Theme> = {
  width: "100%",
  minHeight: "100vh",
  boxSizing: "border-box",
};

/** Full width block */
export const fullWidth: SxProps<Theme> = {
  width: "100%",
  boxSizing: "border-box",
};

/** Constrained content width for hero/cards (e.g. welcome, login card container) */
export const contentMaxWidth = "min(90vw, 42rem)";

/** Constrained width for form fields + button only (e.g. login form, add user form) */
export const formMaxWidth = 340;

/** Main content area: full width, responsive padding (use in layout children) */
export const responsivePageContent: SxProps<Theme> = {
  width: "100%",
  boxSizing: "border-box",
  px: { xs: 0, sm: 0 },
};

/** Responsive section heading */
export const responsiveHeading: SxProps<Theme> = {
  fontSize: { xs: "1.25rem", sm: "1.5rem" },
  fontWeight: 700,
};
